import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpResponse,
  HttpUserEvent
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { Observable } from "rxjs";
import { VtSSOService } from "../services/auth/vt-sso.service";
import { AuthService } from "@app/service/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private keycloakService: KeycloakService,
    private authService: AuthService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent |
    HttpHeaderResponse |
    HttpProgressEvent |
    HttpResponse<any> |
    HttpUserEvent<any>> {
    const authentication = JSON.parse(localStorage.getItem(VtSSOService.requestParamTicketKey) ?? '{}');
    let clonedReq = req.clone({
      headers: req.headers.set('Local-IP-Custom', this.authService.getLocalIp)
    });
    if (authentication
//       && !req.url.includes('/sso/p3/serviceValidate')
      && !req.url.includes('/auth/login')
      && !req.url.includes('/auth/login-sso')
//       && !req.url.includes('/auth/token')
      && !req.url.includes('/auth/reset-forgot-password')
      && !req.url.includes('/auth/forgot-password')
      && !req.url.includes('/auth/introspect-reset-token')) {
      const typeAuth = clonedReq.headers.get('typeAuth')
      if (typeAuth) {
        clonedReq.headers.delete('typeAuth')
      }
      let copiedReq = clonedReq.clone({
        headers: clonedReq.headers.set('Authorization', `${typeAuth == 'vss-hoasao' ? '' : 'Bearer '}${authentication['token']}`)
      });
      return next.handle(copiedReq);
    }
    return next.handle(clonedReq);
  }
}
